import React, {createContext, useContext} from 'react'

import {
  DealFreezeOfferBoxState,
  useDealFreezeOfferBox
} from './useDealFreezeOfferBox'

const DealFreezeOfferBoxContext = createContext<DealFreezeOfferBoxState | null>(
  null
)

interface Props {
  hotelId: string
  surface: 'mobile' | 'desktop'
  children: React.ReactNode
}

// Only the surfaces that render the tag and banner mount this, so offer rows
// elsewhere never evaluate the experiment
export const DealFreezeOfferBoxProvider = ({
  hotelId,
  surface,
  children
}: Props) => {
  const state = useDealFreezeOfferBox({hotelId, surface})

  return (
    <DealFreezeOfferBoxContext.Provider value={state}>
      {children}
    </DealFreezeOfferBoxContext.Provider>
  )
}

export const useDealFreezeOfferBoxContext = () =>
  useContext(DealFreezeOfferBoxContext)
